var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCafeteria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F2EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 30V31H11V30H28ZM27.75 17C28.4404 17 29 17.5596 29 18.25L29.0001 19.025C29.0808 19.0086 29.1644 19 29.25 19H30.75C31.4404 19 32 19.5596 32 20.25V22.75C32 23.4404 31.4404 24 30.75 24H29.25C29.0434 24 28.8484 23.9499 28.6767 23.8611C27.9641 25.7619 26.1431 27.1212 24.0005 27.1533L24 27.75C24 28.4404 23.4404 29 22.75 29H16.25C15.5596 29 15 28.4404 15 27.75L15.0002 27.0394C12.7135 26.5456 11 24.5114 11 22.0769V18.25C11 17.5596 11.5596 17 12.25 17H27.75ZM27.75 18H12.25C12.1119 18 12 18.1119 12 18.25V22.0769C12 24.006 13.3509 25.6602 15.2113 26.062C15.6718 26.1614 16.0004 26.5687 16.0002 27.0398L16 27.75C16 27.8881 16.1119 28 16.25 28H22.75C22.8881 28 23 27.8881 23 27.7491L23.0005 27.1524C23.001 26.6063 23.4396 26.1615 23.9856 26.1534C26.2106 26.1201 28 24.3053 28 22.0769V18.25C28 18.1119 27.8881 18 27.75 18ZM30.75 20H29.25C29.1119 20 29 20.1119 29 20.25V22.75C29 22.8881 29.1119 23 29.25 23H30.75C30.8881 23 31 22.8881 31 22.75V20.25C31 20.1119 30.8881 20 30.75 20ZM17.5 13V16H16.5V13H17.5ZM23.5 13V16H22.5V13H23.5ZM20.5 12V16H19.5V12H20.5Z",
    fill: "#754FFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafeteria);
export default __webpack_public_path__ + "static/media/cafeteria.ad916e1e83c00f60386c81747fcab6ee.svg";
export { ForwardRef as ReactComponent };